type StringWithAutocomplete<T> = T | (string & Record<never, never>);

export type MyopMessageKey = StringWithAutocomplete<keyof typeof MyopMessages | keyof typeof MyopMessages.In>;

export const MyopMessages = {
    //host to component
    'InitRequest': 'InitRequest',
    'InitResponse': 'InitResponse',
    'InitMessage': 'InitMessage',
    'DisposeMessage': 'DisposeMessage',

    'ChangeTextMessage': 'ChangeTextMessage',
    'BindClickMessage': 'BindClickMessage',
    'DetectMyopRefsMessage': 'DetectMyopRefsMessage',

    'ExecuteScriptMessage': 'ExecuteScriptMessage',

    'AddEventListenerMessage': 'AddEventListenerMessage',
    'SetAttributeMessage': 'SetAttributeMessage',

    'CreateRefComponentMessage': 'CreateRefComponentMessage',
    'EnvelopedMessage': 'EnvelopedMessage',

    'GetElementValueMessage': 'GetElementValueMessage',
    'GetAttributeMessage': 'GetAttributeMessage',

    'SetInnerHtml': 'SetInnerHtml',

    //component messages
    'ExecuteComponentMethod': 'ExecuteComponentMethod',
    'SetMutationObserverMessage': 'SetMutationObserverMessage',
    'SetResizeObserverMessage': 'SetResizeObserverMessage',

    'CleanupMessage': 'CleanupMessage',

    // external to host :
    In: {
        'DetectedMyopRefsMessage': 'DetectedMyopRefsMessage',
        'ClickReplayMessage': 'ClickReplayMessage',
        'ExecuteScriptReplyMessage': 'ExecuteScriptReplyMessage',

        'EventListenerCallbackMessage': 'EventListenerCallbackMessage',
        'ElementValueReplayMessage': 'ElementValueReplayMessage',

        "GetAttributeReplayMessage": "GetAttributeReplayMessage",
        'RefComponentCreatedMessage': 'RefComponentCreatedMessage',
        'EnvelopedMessage': 'EnvelopedMessage',

        'MutationObserverMessage': 'MutationObserverMessage',
        'CleanupReplayMessage': 'CleanupReplayMessage',
        'ResizeObserverMessage': 'ResizeObserverMessage'
    }
}
